import { J3PanelBase } from './J3PanelBase';

export class J3LinkPanel extends J3PanelBase{    
    constructor(debugLvl = 0, name = '', enable=true, visible=true, public btnContainerID:string, onOffButtonID:string, className:string, imageFile:string, linkURL='#'){
        super();
        this.name = name;
        if(enable){
            const btnContainer = document.querySelector('#' + btnContainerID) as HTMLElement;
            if(btnContainer){
                console.log('J3LinkPanel', btnContainerID, onOffButtonID, className);
                const li = document.createElement('li');
                li.setAttribute("id", onOffButtonID);   //li要素にIDを追加
                li.classList.add(className);
                btnContainer.appendChild(li);

                li.innerHTML = '';    //子要素をすべて削除
                let htmlText:string;
                if(linkURL == '#' || linkURL == ''){
                    //リンクなし
                    htmlText = '<img src="' + imageFile + '" alt="Logo">';
                }else{
                    //リンク付き
                    htmlText = '<figure><button type="button" id="##" onclick="location.href=\'' + linkURL + '\'"><img src="' + imageFile + '" alt="Logo"></button></figure>';
                }
                li.innerHTML = htmlText;

                if (visible){
                    this.ShowButton(li);
                }else{
                    this.HideButton(li);
                }
            }
        }
    }

    DummyMethod(){
        console.log('J3LinkPanel DummyMethod');
    }
}